import {
  ColorsConfig,
  TypographyConfig,
  BorderConfig,
  NeumorphismConfig,
} from '@carton-org/react-neumorphism';

export const lanuraColorsConfig: ColorsConfig = {
  backgroundColor: '#f8fafc', // Matches body background
  lightShadow: 'rgba(255, 255, 255, 0.7)',
  darkShadow: 'rgba(0, 0, 0, 0.15)',
  activeBackgroundColor: '#e8e8e8',
  hoverBackgroundColor: '#f0f0f0',
};

export const lanuraTypographyConfig: TypographyConfig = {
  fontFamily:
    '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  fontColor: '#0f172a', // --lanura-text
};

export const lanuraBorderConfig: BorderConfig = {
  borderColor: 'rgba(255, 255, 255, 0.5)',
  borderRadius: '12px', // Matches existing rounded corners
  borderWidth: '1px',
  borderStyle: 'solid',
};

export const lanuraNeumorphismConfig: NeumorphismConfig = {
  distance: '4px', // Reduced from 8px for more subtle shadows
  blur: '8px', // Reduced from 16px for more subtle shadows
};
